/* eslint-disable @typescript-eslint/no-empty-function */

import { ActivationEnd, NavigationEnd, NavigationStart, type Router } from '@angular/router';
import { type AppService } from '@core';
import { type ChildClient } from '@models';
import { type Store } from '@ngrx/store';
import { AuthActions, AuthSelectors, ClientManagementActions, ClientManagementSelectors, type UserState } from '@ngrx-store';
import { distinctUntilChanged, filter, map, type Observable } from 'rxjs';

export abstract class StartSettingsClass {
  loading: Observable<boolean> | undefined;
  isLoggedIn = false;
  clientsList: ChildClient[] = [];
  user: UserState | undefined;

  constructor(public store: Store, public router: Router, public appService: AppService) {
    const userProfile = localStorage.getItem('user');

    if (userProfile) {
      const user = JSON.parse(userProfile);

      this.store.dispatch(AuthActions.login({ user }));
    }
    this.store.select(ClientManagementSelectors.selectChildClients).subscribe(clientList => {
      this.clientsList = clientList || [];
      if (this.clientsList.length) {
        this.appService.managingClientId = this.clientsList.find(client => client.isManagingClient)?.id || this.clientsList[0].clientId;
      }
    });
  }

  onNavigationEnd() { }
  onActivationEnd(_event: ActivationEnd) { }
  onUserSelected(_isLoggedIn: boolean, _user: UserState) { }

  init() {
    this.store.select(AuthSelectors.selectUser).subscribe(user => {
      this.isLoggedIn = !!user.id;
      this.user = user;
    });

    this.router.events.subscribe(async event => {
      // Don't do any redirects if user is unauthorized
      if (!this.isLoggedIn || !this.user) {
        return;
      }
      this.onUserSelected(this.isLoggedIn, this.user);
      if (event instanceof NavigationStart) {
        const params = event.url.split('?')[1];
        const clientId = new URLSearchParams(params).get('clientId');

        // Add query param "clientId" if route doesn't contain it
        if (!clientId) {
          await this.router.navigateByUrl(
            `${event.url}${event.url.indexOf('?') < 0 ? '?' : '&'}clientId=${this.appService.currentClient}`,
          );

          return;
        }

        // Check if provided "clientId" param in URL has appropriate client
        if (clientId !== this.appService.currentClient) {
          const availableClient = this.clientsList.find(({ id }) => id === clientId);
          // Select new current client if it is available

          if (availableClient) {
            this.store.dispatch(ClientManagementActions.clientIdChanged({ clientId: availableClient.id }));
          } else {
            await this.router.navigate(['/dashboard'], {
              queryParams: { clientId: this.appService.currentClient },
              queryParamsHandling: 'merge',
            });
          }
        }
      }

      if (event instanceof ActivationEnd) {
        this.onActivationEnd(event);
      }
    });

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(event => event.url.split('?')[0]),
        distinctUntilChanged(),
      )
      .subscribe(() => this.onNavigationEnd());
  }
}
